import { Observable } from 'rxjs';
import { DocumentCheckModel, DocumentRequest } from '@src/core/domain/charge/document-check.model';

export abstract class DocumentCheckModelRepository {
  abstract getDocumentCheck(obj: DocumentRequest): Observable<DocumentCheckModel>;
}
